import React from 'react';
import {connect} from "react-redux";
import './filterModal.css';
import InputSearchFilter from '../Shared/InputSearchFilter';
import SVG from "react-inlinesvg";
import searchIcon from '../../assets/icons/searchFilter.svg'
import {addSearchChips} from "../../actions/searchActions";
import link from "react-router-dom/Link";

class FilterModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            options: [],
            category: false,
            checked: false,
            search_terms: [],
            moreOptions: [],
            query: "",
            seller: false,
            search_by_device: false,
            search_by_demo_type: false,
            additional_features: false,
            subcategory: false,
            disable: false,
            links: {
                filter_mock: false,
                filter_live: false
            },
            width: false,
        };
        this.test = React.createRef();
    }
    componentWillMount() {
        if(this.props.title === 'Functionality' || this.props.title === 'Vertical'){
            window.addEventListener('resize', this.handleResize)
            setTimeout(() => {
                let width = this.test.current.scrollWidth;
                let left = "0px";
                if(this.props.title === 'Functionality'){
                    let container1 = document.getElementById('functionality');
                    if(container1 !== null){
                        let container = document.getElementById('filter-table-content').getBoundingClientRect()
                        container1 = container1.getBoundingClientRect();
                        let offset = container.top - container1.top;
                        let offset2 = container.right - container1.right;
                        left =  offset2 - 100;

                        if(this.props.options.length <= 51){
                            if(Math.sign(left) !== -1){
                                left = '-' + left + 'px'
                            }else{
                                left = left + 'px'
                            }
                        }
                        // left = container.left + container.width / 2 - container1.width / 2 + offset;
                    }
                }
                if(this.props.title === 'Vertical'){
                    if(width >= 250){
                        width = width + 150;
                    }else{
                        width = width + 150;
                    }
                }
                this.setState({
                    left,
                    width,
                })
            }, 2)
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    componentDidMount() {
        let options = this.props.options;
        let search_terms = [];
        let term = [];
        let filter = this.props.filterItems;
        let found = [];
        let linkObject = {};
        let disable = true;
        let titleArray = ["Seller", "Search By Device", "Search By Demo Type", "Additional Features", "Subcategory"]
        if(this.props.title === "More"){
            options = options.filter(o => {
                if(titleArray.includes(o.title)){
                   o.options = o.options.map(category => {
                        term.push(category)
                       return category
                    })
                    return o;
                }
            })
            let filterArray = filter.length === 0 ? [] : this.props.filterItems;
            if(filterArray !== undefined && filterArray.length > 0){
                filterArray.some(r => options.some(s => {
                    let type = r.type.replace('filter_', "");
                    for (const foundItem in s.options) {
                        let item = s.options[foundItem];
                        if(item.type === type && item.name === r.name){
                            item.selected = true;
                            found.push(item)
                        }
                    }
                }))
                search_terms = found;
            }
            options = term;
        }else{
            let links = {}
            let filterArray = filter.length === 0 ? [] : [...this.props.filterItems, ...options];
            filterArray = filterArray.filter((v,i,a)=>a.findIndex(v2=>(v.name === v2.name && v.selected !== undefined && v2.selected !== undefined &&  v.selected === v2.selected))===i)
            options = options.map(o => {
              filterArray.forEach(filter => {
                    if(filter.name === o.name){
                        if(o.selected !== undefined){
                            o.selected = true;
                        }
                    }
                })
                return o;
            })
            if(this.props.title === "Links"){
                let mock = this.props.terms.some( vendor => vendor['name'] === 'Mock Unit' )
                let live = this.props.terms.some( vendor => vendor['name'] === 'Live Unit' )
                if(mock && !live){
                    linkObject.filter_mock = true;
                    disable = false;
                }else if(live && !mock){
                    linkObject.filter_live = true;
                    disable = false;
                }else{
                    disable = false
                }

                if(!disable){
                    if(this.state.links.filter_live || live){
                        links['name'] = "live" ;
                        links['type'] = 'creative_unit_type';
                        search_terms = [...search_terms, links];
                    }
                    if(this.state.links.filter_mock || mock){
                        links['name'] = "mock";
                        links['type'] = 'creative_unit_type';
                        search_terms = [...search_terms, links];
                    }
                }
                if(filterArray !== undefined && filterArray.length > 0){
                    filterArray.forEach(item => {
                        if(item.type !== undefined){
                            if(item.type.includes('filter_creative_unit_type')){
                                if(item.name === 'mock'){
                                    linkObject.filter_mock = true;
                                }
                                if(item.name === 'live'){
                                    linkObject.filter_live = true;
                                }
                            }
                        }
                    })
                }
            }
            if(filterArray !== undefined && filterArray.length > 0){
                filterArray.some(r => options.some(s => {
                    if(r.type !== undefined){
                        let type = r.type.replace('filter_', "");
                        if(s.name === r.name && s.type === type){
                            if(!s.main){
                                s.selected = true
                                found.push(s)
                            }

                        }
                    }
                }))
                search_terms = found;
            }else{
                search_terms = []
            }
        }
        this.setState(prevState => ({
            search_terms,
            links: {
                ...this.state.links,
                ...linkObject
            },
            disable,
            options
        }));
    }
    handleResize = () => {
        if(this.props.title === 'Functionality'){
            let container = document.getElementById('filter-table-content').getBoundingClientRect();
            let container1 = document.getElementById('functionality').getBoundingClientRect();
            let offset2 = container.right - container1.right;
            this.setState({
                left: offset2,
            })
        }
    }
    onSelectAll = (event, category) => {
        let options = this.state.options;
        let search_terms = this.state.search_terms;
        let arr = search_terms.length > 0 ? search_terms : [];
        let allSelected = false;
        let selected = [];
        if(this.props.title === "More"){
            let id = event.target.id;
            selected = selected = options.map(o => {
                if(o.type === id){
                    o.selected = allSelected;
                    if(allSelected){
                        let obj = {};
                        obj['name'] = o.name;
                        obj['type'] = o.type;
                        arr.push(obj);
                    }
                }
                return o;
            })
            let updatedOptions = this.state.search_terms.filter(s => s.type === category);
            let stateOptions = this.state.search_terms.filter(s => s.type !== category);
            this.props.clear(this.props.title, updatedOptions);
            search_terms = stateOptions;
            this.setState({search_terms, options: selected, [event.target.id]: event.target.checked})
        }else{
            selected = options.map(o => {
                o.selected = false;
                if(allSelected){
                    let obj = {};
                    obj['name'] = o.name;
                    obj['type'] = o.type;
                    arr.push(obj);
                }
                return o;
            })

            search_terms = [];
            this.props.clear(this.props.title)
            this.setState({search_terms, options: selected, checked: false})
        }
    }
    handleMultiCheckboxChange = (e) => {
        const {name, checked} = e.target;
        let search_name = name.toLowerCase();
        let links = Object.assign({}, this.state.links);
        if(search_name === "creative format"){
            search_name = "creative_type";
        }
        const value = e.target.value;
        let search_terms = this.state.search_terms;
        let arr = search_terms.length > 0 ? search_terms : [];
        let searchObj = {};
        if(search_name === 'creative_unit_type' && value === "mock"){
            links.filter_mock = checked;
        }
        if(search_name === 'creative_unit_type' && value === "live"){
            links.filter_live = checked;
        }
        let newOptions = this.state.options.map(item => {
            if(item.name === value && item.type === search_name){
                item.selected = checked;
            }
            return item;
        })
        let j = false;
        if(checked){
            j = arr.some(cat => cat.name === value);
            if(!j){
                searchObj['name'] = value;
                searchObj['type'] = search_name;
                arr.push(searchObj);
            }
        }else{
           let indexOfObject = arr.findIndex(object => {
                if(object.name === value){
                    return object;
                }
            });
            arr.splice(indexOfObject, 1);
        }
        search_terms = arr;
        this.setState({options: newOptions, search_terms, checked: true, links});
    }
    applyFilters = () => {
        let search_terms = this.state.search_terms;
        for (const searchTermsKey in search_terms) {
            let item = search_terms[searchTermsKey];
            item.selected = true;
            item.type = "filter_" + item.type;
        }
        this.props.setSearchTerms(search_terms, this.props.title);
    }
    showMoreContent = () => {
        const {options, query} = this.state;
        let filterSeller = options.filter(op => op.type === "seller");
        let filterDevice = options.filter(op => op.type === "search_by_device");
        let filterSize = options.filter(op => op.type === "search_by_demo_type");
        let filterSubcategory = options.filter(op => op.type === "subcategory");
        let filterAdditional = options.filter(op => op.type === "additional_features");
        return(
            <div className="more--modal-container">
                <div className="more--modal-column">
                    <p>Seller</p>
                    <div className="filterIcon-box">
                        <span className="filterIcon"><SVG src={searchIcon}/></span>
                        <InputSearchFilter options={options} sendQuery={this.getSearchQuery}/>
                    </div>
                    <div className="more--modal-search-options">
                        <label htmlFor="selectAll">
                            <span className="clear-all" id="seller"  onClick={(e) => this.onSelectAll(e,'seller')}>Clear All</span>
                        </label>
                        {filterSeller.length > 0 ? filterSeller.filter(op => {
                            if (query === '') {
                             return op
                        }else if(op.name.toLowerCase().includes(query.toLowerCase())) {
                            return op;
                        }
                        }).map((post, index) => (
                            <label htmlFor={post.name} key={index}>
                                <input type="checkbox" name={post.type} value={post.name} disabled={post.main} checked={post.selected} id={post.name} onChange={this.handleMultiCheckboxChange}/>
                                {post.name}
                            </label>
                        )) : ""
                        }
                    </div>
                </div>
                <div className="more--modal-column">
                    <p className="column-header">Device</p>
                    <label htmlFor="selectAll" className="more--label">
                        <span className="clear-all" id="search_by_device" onClick={(e) => this.onSelectAll(e,'search_by_device')}>Clear All</span>
                    </label>
                    {filterDevice.map((op,key) => {
                        return(
                        <label htmlFor={op.name+'device'} key={key} className="more--label">
                        <input type="checkbox" name={op.type} value={op.name} disabled={op.main}  checked={op.selected} id={op.name+'device'} onChange={this.handleMultiCheckboxChange}/>
                            {op.name}
                        </label>
                        )
                    })}
                </div>
                <div className="more--modal-column">
                    <p className="column-header">Size</p>
                    <label htmlFor="selectAll" className="more--label">
                        {/*<input type="checkbox" id="search_by_demo_type" onChange={this.onSelectAll} checked={this.state.search_terms.length > 0 ? this.state.search_terms.some(so => so.type === "search_by_demo_type") : false}/>*/}
                        <span className="clear-all" id="search_by_demo_type" onClick={(e) => this.onSelectAll(e,'search_by_demo_type')}>Clear All</span>
                    </label>
                    {filterSize.map((op,key) => {
                        return(
                            <label htmlFor={op.name} key={key} className="more--label">
                                <input type="checkbox" name={op.type} value={op.name} disabled={op.main} checked={op.selected} id={op.name} onChange={this.handleMultiCheckboxChange}/>
                                {op.name}
                            </label>
                        )
                    })}
                </div>
                <div className="more--modal-column">
                    <div className="more--modal-inner-row">
                        <p className="column-header">Additional Features</p>
                        <label htmlFor="selectAll" className="more--label" >
                            <span className="clear-all" id="additional_features" onClick={(e) => this.onSelectAll(e,'additional_features')}>Clear All</span>
                        </label>
                        {filterAdditional.map((op,key) => {
                            return(
                                <label htmlFor={op.name} key={key} className="more--label">
                                    <input type="checkbox" name={op.type} value={op.name}  disabled={op.main} checked={op.selected} id={op.name} onChange={this.handleMultiCheckboxChange}/>
                                    {op.name}
                                </label>
                            )
                        })}
                    </div>

                    <div className="more--modal-inner-row">
                        <p className="more--label">Campaign Subcategories</p>
                        <label htmlFor="selectAll" className="more--label">
                            <span className="clear-all" id="subcategory" onClick={(e) => this.onSelectAll(e,'subcategory')}>Clear All</span>
                        </label>
                        {filterSubcategory.map((op,key) => {
                            return(
                                <label htmlFor={op.name} key={key} className="more--label">
                                    <input type="checkbox" name={op.type} value={op.name}  disabled={op.main} checked={op.selected} id={op.name} onChange={this.handleMultiCheckboxChange}/>
                                    {op.name}
                                </label>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
    showResults = () => {
        const {title} = this.props;
        const {options, query} = this.state;
        if(title === "Brand" || title === "Campaign" || title === "Designer"){
            return options.filter(op => {
                if (query === '') {
                    return op;
                } else if (op.name.toLowerCase().includes(query.toLowerCase())) {
                    return op;
                }
            }).map((post, index) => (
                <label htmlFor={post.name} key={index} >
                    <input type="checkbox" name={title} value={post.name}  disabled={post.main} checked={post.selected} id={post.name} onChange={this.handleMultiCheckboxChange}/>
                    {post.name}
                </label>
            ))
        }
        if(title === "Links"){
            let mock = this.props.terms.some( vendor => vendor['name'] === 'Mock Unit' )
            let live = this.props.terms.some( vendor => vendor['name'] === 'Live Unit' )
            return(
                <React.Fragment>
                    {mock && !live &&  <label htmlFor='plinks'>
                        <input type="checkbox" name="creative_unit_type" value="mock" id="plinks" disabled={this.state.disable} checked={this.state.links.filter_mock} onChange={this.handleMultiCheckboxChange}/>
                        Mockups
                    </label>}
                    {live && !mock && <label htmlFor='dlinks'>
                        <input type="checkbox" name="creative_unit_type" value="live" id="dlinks" disabled={this.state.disable} checked={this.state.links.filter_live} onChange={this.handleMultiCheckboxChange}/>
                        Live Units
                    </label>}
                    {mock && live &&
                        <div>
                            <label htmlFor='plinks'>
                                <input type="checkbox" name="creative_unit_type" value="mock" id="plinks" disabled={this.state.disable} checked={this.state.links.filter_mock} onChange={this.handleMultiCheckboxChange}/>
                                Mockups
                            </label>
                            <label htmlFor='dlinks'>
                                <input type="checkbox" name="creative_unit_type" value="live" id="dlinks" disabled={this.state.disable} checked={this.state.links.filter_live} onChange={this.handleMultiCheckboxChange}/>
                                Live Units
                            </label>
                        </div>

                    }
                </React.Fragment>
            )
        } else{
            return options.map((op,key) => {
                if(op.name !== "Expandable" && op.name !== "Interstitial"){
                    return(
                        <label htmlFor={op.name} key={key}>
                            <input type="checkbox" name={title} value={op.name} id={op.name}  disabled={op.main} checked={op.selected} onChange={this.handleMultiCheckboxChange}/>
                            {op.name}
                        </label>
                    )
                }
            })
        }
    }
    getSearchQuery = (q) => {
        this.setState({query: q})
    }


    render(){
        const {title} = this.props;
        const {options} = this.state;
        let showSearchBar = false;
        let style = this.props.title === "Functionality" ? {
            right: this.state.left !== undefined ? this.state.left : 'initial',
        } : {};
        if(title === "Brand" || title === "Campaign" || title === "Designer"){
            showSearchBar = true;
        }
        return(
            <div className="search-filter-wrapper">
                <div className="search-filter-modal"  style={style} ref={this.props.innerRef}>
                    <div className="filterIcon-box">
                        {showSearchBar && <span className="filterIcon"><SVG src={searchIcon}/></span>}
                        {showSearchBar && <InputSearchFilter options={options} sendQuery={this.getSearchQuery}/>}
                    </div>
                    {title !== "Links" && title !== "More" && <span className="clear-all" onClick={(e) => this.onSelectAll(e,'default')}>Clear All</span>}
                    {title !== "More" ?  (<div className="search-option-section" ref={(node) => { this.test.current = node; }} id={this.props.id !== undefined ? this.props.id : ""}>
                        {this.showResults()}
                    </div>) : this.showMoreContent()}

                    <div className="filter-btn-container">
                        <button
                            className={`apply--btn ${this.props.title === "Links" && this.state.disable ? 'disable' : ''}` }
                            disabled={this.props.title === "Links" && this.state.disable}
                            onClick={this.applyFilters}>Apply Filters</button>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(null)(FilterModal);